import { Nullish, RecruiterDetailsResponse } from "../types";

export function getUserDetails(): Nullish<RecruiterDetailsResponse> {
  // Check if user details exist in session storage
  const userDetailsString = sessionStorage.getItem("userDetails");

  if (userDetailsString) {
    // If user details exist, parse the JSON string and return the object
    return JSON.parse(userDetailsString);
  } else {
    // If user details do not exist, return userDetails;
    return null;
  }
}